import { Link } from "gatsby"
import React from "react"
import site from '../constants/site' 

import './header.css'

const Header = ({ pathname }) => {
  const renderLinks = (position) => {
    return site.headerLinks.map((link) => {
      let currentPage
      if(link.uri === pathname) currentPage = true
      if(link.position !== position) return null
      if(link.isExternal === true) return <a href={link.uri} className="header-link" target="_blank" rel="noreferrer">{link.label}</a>
      if(link.isExternal === false) return <Link to={link.uri} className={`header-link ${currentPage ? 'underline' : ''}`} >{link.label}</Link>
      return null
    })
  }
  return (
    <header>
      <div id="header-left">
        {renderLinks('left')}
      </div>
      <div id="header-right">
        {renderLinks('right')}
      </div>
    </header>
  )
}

export default Header
